import React, { PropsWithChildren, ReactElement } from "react";
import { BACKWARDS_SVG } from "../../utils/svgs";
import { AppIcon } from "./AppIcon";
import { If } from "./If";

interface Props {
  onClick: () => void;
}

export function AppDialPadButton(props: PropsWithChildren<Props>): ReactElement {
  return (
    <div className="AppDialPadButton">
      <If condition={props.children !== null}>
        <div
          className="AppDialPadButtonContainer"
          onClick={props.onClick}
          data-button={props.children}
        >
          {props.children === "backwards" ? (
            <AppIcon icon={BACKWARDS_SVG} stroke="blue-gray" />
          ) : (
            props.children
          )}
        </div>
      </If>
    </div>
  );
}
